import { createContext, useState, ReactNode } from "react";
import { MapOfBrands } from "~src/types/brandMapping";

type BrandMappingContextType = {
  mapOfBrandsContext: MapOfBrands[] | undefined;
  setMapOfBrandsContext: React.Dispatch<
    React.SetStateAction<MapOfBrands[] | undefined>
  >;
};

const BrandMappingContext = createContext<BrandMappingContextType | null>(null);

const BrandMappingProvider = ({ children }: { children: ReactNode }) => {
  const [mapOfBrandsContext, setMapOfBrandsContext] = useState<
    MapOfBrands[] | undefined
  >(undefined);

  const contextValue = {
    mapOfBrandsContext,
    setMapOfBrandsContext,
  };

  return (
    <BrandMappingContext.Provider value={contextValue}>
      {children}
    </BrandMappingContext.Provider>
  );
};

export { BrandMappingContext, BrandMappingProvider };
